module.exports = __webpack_public_path__ + "static/media/new-background-jet.f1fb7c4d.jpg";